export default "__VITE_ASSET__c0f59d01__"